/**
 * Common storage keys used throughout the application
 * These keys are used with the StorageService to maintain consistency
 */
export const STORAGE_KEYS = {
  // Authentication related
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_CREDENTIALS: 'user_credentials',
  USER_PROFILE: 'user_profile',
  REMEMBER_ME: 'remember_me',

  // Application settings
  APP_SETTINGS: 'app_settings',
  THEME: 'theme',
  LANGUAGE: 'language',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',

  // User preferences
  USER_PREFERENCES: 'user_preferences',
  DASHBOARD_LAYOUT: 'dashboard_layout',
  TABLE_PREFERENCES: 'table_preferences',

  // Cache related
  API_CACHE: 'api_cache',
  DATA_CACHE: 'data_cache',

  // Form data
  FORM_DATA: 'form_data',
  DRAFT_DATA: 'draft_data',

  // Navigation
  LAST_ROUTE: 'last_route',
  NAVIGATION_HISTORY: 'navigation_history',

  // Notifications
  NOTIFICATION_SETTINGS: 'notification_settings',
  READ_NOTIFICATIONS: 'read_notifications',

  // Temporary data
  TEMP_DATA: 'temp_data',
  SESSION_DATA: 'session_data',

  // Feature flags
  FEATURE_FLAGS: 'feature_flags',

  // Error logs
  ERROR_LOGS: 'error_logs',

  // Analytics
  ANALYTICS_DATA: 'analytics_data',
  USER_BEHAVIOR: 'user_behavior',
} as const;

/**
 * Storage key prefixes for different modules
 */
export const STORAGE_PREFIXES = {
  APP: 'app_',
  AUTH: 'auth_',
  USER: 'user_',
  CACHE: 'cache_',
  FORM: 'form_',
  NAV: 'nav_',
  NOTIFICATION: 'notification_',
  TEMP: 'temp_',
  FEATURE: 'feature_',
  ERROR: 'error_',
  ANALYTICS: 'analytics_',
} as const;

/**
 * Default TTL (Time To Live) values in milliseconds
 */
export const STORAGE_TTL = {
  SHORT: 5 * 60 * 1000, // 5 minutes
  MEDIUM: 30 * 60 * 1000, // 30 minutes
  LONG: 2 * 60 * 60 * 1000, // 2 hours
  DAY: 24 * 60 * 60 * 1000, // 24 hours
  WEEK: 7 * 24 * 60 * 60 * 1000, // 7 days
  MONTH: 30 * 24 * 60 * 60 * 1000, // 30 days
  PERMANENT: 0, // No expiration
} as const;
